// 环境
export const env = process.env.NODE_ENV;
console.log(`当前环境：${env}`);

// 请求域名
export const baseURL = {
  development: 'http://localhost:8080',
  production: `${window.location.origin}/icbt-test-api`,
}[env]

// 请求域名
export const access_token = {
  development: 'dev_access_token',
  production: 'access_token',
}[env]




// 登录
export const toLogin = () => {}
